import React, { useEffect } from "react";
import { Form, InputNumber, Input, Typography } from "antd";
import { elvis } from "../../Utils"

const { Title } = Typography;

const StaffForm = props => {
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        number: props.record.asset.number,
        activities: props.record.asset.activities,
        details: props.record.asset.details
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        number: props.record.asset.number,
        activities: props.record.asset.activities,
        details: props.record.asset.details
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;
    
    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);
    
    const newAsset = { ...props.record };
    newAsset.asset.number = elvis(values.number);
    newAsset.asset.activities = elvis(values.activities);
    newAsset.asset.details = elvis(values.details);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form 
      form={form}
      {...formItemLayout} 
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title 
        className="details_form_header"
        title="Asset details"
        subTitle="Working Staff"
      />
      
      <Form.Item 
        label="Total number" 
        name="number"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      
      <Form.Item 
        label="Activities performed" 
        name="activities"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>
      
      <Form.Item 
        label="Details" 
        name="details"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default StaffForm;